var _rect, _rect2, _rect3, _rect4, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSoftwareDetails(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint0_linear_3959_6465)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 59,
    height: 59,
    rx: 29.5,
    stroke: "url(#paint1_linear_3959_6465)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint2_linear_3959_6465)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8.5,
    y: 8.5,
    width: 43,
    height: 43,
    rx: 21.5,
    stroke: "url(#paint3_linear_3959_6465)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1538 33.8462C35.7692 33.8462 35.3846 33.6923 35.0769 33.3846L32.7692 31.0769C32.4615 30.7692 32.3077 30.3846 32.3077 30C32.3077 29.6154 32.4615 29.2308 32.7692 28.9231L35.0769 26.6154C35.3846 26.3077 35.7692 26.1538 36.1538 26.1538C36.5385 26.1538 36.9231 26.3077 37.2308 26.6154L39.5385 28.9231C39.8462 29.2308 40 29.6154 40 30C40 30.3846 39.8462 30.7692 39.5385 31.0769L37.2308 33.3846C36.9231 33.6923 36.5385 33.8462 36.1538 33.8462ZM36.1538 27.6923L33.8462 30L36.1538 32.3077L38.4615 30L36.1538 27.6923ZM30 27.6923C29.6154 27.6923 29.2308 27.5385 28.9231 27.2308L26.6154 24.9231C26.3077 24.6154 26.1538 24.2308 26.1538 23.8462C26.1538 23.4615 26.3077 23.0769 26.6154 22.7692L28.9231 20.4615C29.2308 20.1538 29.6154 20 30 20C30.3846 20 30.7692 20.1538 31.0769 20.4615L33.3846 22.7692C33.6923 23.0769 33.8462 23.4615 33.8462 23.8462C33.8462 24.2308 33.6923 24.6154 33.3846 24.9231L31.0769 27.2308C30.7692 27.5385 30.3846 27.6923 30 27.6923ZM30 21.5385L27.6923 23.8462L30 26.1538L32.3077 23.8462L30 21.5385ZM30 40C29.6154 40 29.2308 39.8462 28.9231 39.5385L26.6154 37.2308C26.3077 36.9231 26.1538 36.5385 26.1538 36.1538C26.1538 35.7692 26.3077 35.3846 26.6154 35.0769L28.9231 32.7692C29.2308 32.4615 29.6154 32.3077 30 32.3077C30.3846 32.3077 30.7692 32.4615 31.0769 32.7692L33.3846 35.0769C33.6923 35.3846 33.8462 35.7692 33.8462 36.1538C33.8462 36.5385 33.6923 36.9231 33.3846 37.2308L31.0769 39.5385C30.7692 39.8462 30.3846 40 30 40ZM30 33.8462L27.6923 36.1538L30 38.4615L32.3077 36.1538L30 33.8462ZM23.8462 33.8462C23.4615 33.8462 23.0769 33.6923 22.7692 33.3846L20.4615 31.0769C20.1538 30.7692 20 30.3846 20 30C20 29.6154 20.1538 29.2308 20.4615 28.9231L22.7692 26.6154C23.0769 26.3077 23.4615 26.1538 23.8462 26.1538C24.2308 26.1538 24.6154 26.3077 24.9231 26.6154L27.2308 28.9231C27.5385 29.2308 27.6923 29.6154 27.6923 30C27.6923 30.3846 27.5385 30.7692 27.2308 31.0769L24.9231 33.3846C24.6154 33.6923 24.2308 33.8462 23.8462 33.8462ZM23.8462 27.6923L21.5385 30L23.8462 32.3077L26.1538 30L23.8462 27.6923Z",
    fill: "#A685FA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3959_6465",
    x1: 4.93903,
    y1: 63.2927,
    x2: 62.7439,
    y2: -4.02439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3959_6465",
    x1: 59.8171,
    y1: -7.68292,
    x2: 4.93902,
    y2: 60,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3959_6465",
    x1: 3.20968,
    y1: 10.4839,
    x2: 51.8226,
    y2: 52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#A685FA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3959_6465",
    x1: 60.6935,
    y1: 61.9355,
    x2: 9.59677,
    y2: 25.7419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A685FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#A685FA",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoftwareDetails);
export default __webpack_public_path__ + "static/media/software-details.6d023d8c63c11beb283b7e6890554013.svg";
export { ForwardRef as ReactComponent };